module.exports = __webpack_public_path__ + "static/img/li1_2.3120c8e1.png";